export function sortAlphabetically(list, key = 'label') {
	return list.sort(function (a, b) {
		if (key) return a[key].toLowerCase() == b[key].toLowerCase() ? 0 : +(a[key].toLowerCase() > b[key].toLowerCase()) || -1;
		else return a.toLowerCase() == b.toLowerCase() ? 0 : +(a.toLowerCase() > b.toLowerCase()) || -1;
	});
}

export function sortByNewest(list, key = 'date') {
	return list.sort(function (a, b) {
		return a[key] - b[key];
	});
}

export function generateUniqueId() {
	return Math.random()
		.toString(36)
		.slice(2);
}

export function stripExtension(name) {
	return name
		.split(".")
		.filter((value, key) => key < name.split(".").length - 1)
		.join(".");
}

export function stripTimestampAndExtension(name) {
	return name
		.split(".")
		.filter((value, key) => key < name.split(".").length - 2)
		.join(".");
}

export function stripTimestamp(name) {
	return name
		.split(".")
		.filter((value, key) => key < name.split(".").length - 2 || key > name.split(".").length - 2)
		.join(".");
}

export function capitalizeFirstLetter(string) {
	if (string) return string[0].toUpperCase() + string.slice(1);
}

export function formatVideoTime(time) {
	let t = parseInt(time);
	return parseInt(t / 60) + ":" + (t % 60 < 10 ? "0" + (t % 60) : t % 60);
}

export function detectSafari() {
	return navigator.userAgent.match(/Version\/([0-9\._]+).*Safari/);
}
